import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link, matchPath, withRouter } from 'react-router-dom';

import './styles.scss';

import { isNilOrEmpty } from '../../util/redux';
import { routes } from '../../routes';
import { apiLogout } from '../../api/user';
import magic from '../../util/magic';

import NavDropdown from '../NavBar/NavDropdown';
import Avatar from '../Avatar';

const mapStore = (store) => ({
  user: store.user,
});

const propTypes = {
  user: PropTypes.object,
  location: PropTypes.object,
};

class Header extends Component {
  render() {
    const { user, location } = this.props;
    const isAdmin = user.role === magic.adminRole;
    const inAdminPanel = matchPath(location.pathname, { path: routes.admin.dashboard });

    return (
      <nav className="navbar navbar-expand-md navbar-light">
        <div className="container">
          <div className="row">
            <div className="col" />
            <div className="brand-col col">
              {inAdminPanel ? (
                <Link className="navbar-brand admin" to={routes.admin.dashboard} />
              ) : (
                <Link className="navbar-brand" to={routes.dashboard} />
              )}
            </div>
            <div className="col d-flex justify-content-end align-items-center">
              {isNilOrEmpty(user) ? (
                <div className="navbar-nav">
                  <Link className="nav-link" to={routes.login}>
                    Login
                  </Link>
                  <Link className="nav-link" to={routes.register}>
                    Create Account
                  </Link>
                </div>
              ) : (
                <div className="nav">
                  <NavDropdown right className="p-0 border-0" as={<Avatar src={user.avatar} mini />}>
                    {isAdmin && (
                      <Link to={inAdminPanel ? routes.dashboard : routes.admin.dashboard} className="dropdown-item">
                        {inAdminPanel ? 'Normal' : 'Admin'}
                      </Link>
                    )}
                    <Link to={routes.editProfile.root} className="dropdown-item">
                      Edit Profile
                    </Link>
                    <Link to={routes.payments.root} className="dropdown-item">
                      Payment History
                    </Link>
                    <button
                      type="button"
                      onClick={() => apiLogout().then(() => (window.location.href = routes.dashboard))}
                      className="dropdown-item"
                    >
                      Logout
                    </button>
                  </NavDropdown>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

Header.propTypes = propTypes;

export default withRouter(connect(mapStore)(Header));
